import React , { Component } from "react"

import 'babel-polyfill'
import 'typeface-roboto'

import ReactDOM from 'react-dom'
import history from './@fuse/history'

import './@fuse/react-table-defaults'
import './@fuse/styles/index.css'

import JssProvider from 'react-jss/lib/JssProvider'

import { create } from 'jss';
import { createGenerateClassName , jssPreset } from '@material-ui/core/styles'

import registerServiceWorker from './@fuse/registerServiceWorker'

import { Provider } from 'react-redux'
import { Router   } from 'react-router-dom'

import {FuseLayout, FuseTheme } from '@fuse'

import routes from './app/routes'

import Toolbar       from './app/display/Toolbar'
import NavbarContent from './app/display/NavbarContent'
import NavbarHeader  from './app/display/NavbarHeader'
import Footer        from './app/display/Footer'

import config from './app/configs/config'

import jssExtend from 'jss-extend'
import store     from './@fuse/store'

import Moment from 'react-moment'

import { Helmet } from 'react-helmet'

import moment from 'moment/moment'
import 'moment/locale/fr'

Moment.globalLocale = 'fr';
moment.locale();

Component.prototype.toString = function()
{
    return '[' + this.constructor.name + ']';
};

const jss = create(
{
    ...jssPreset(),
    plugins: [...jssPreset().plugins, jssExtend()]
});

jss.options.insertionPoint = document.getElementById('jss-insertion-point') ;

const generateClassName = createGenerateClassName();

ReactDOM.render(
       <JssProvider className="application" jss={jss} generateClassName={generateClassName}>
            <Provider store={store}>
                <Router history={history}>
                    <div id='application' className="w-full h-full">
                        <Helmet { ...config.helmet } >
                            <title>{ config.helmet.title }</title>
                            <meta name="description" content="Helmet application" />
                            <link rel="canonical" href={ config.helmet.homepage } />
                        </Helmet>
                        <FuseTheme>
                            <FuseLayout
                                routes        = { routes }
                                toolbar       = { <Toolbar/> }
                                navbarHeader  = { <NavbarHeader/> }
                                navbarContent = { <NavbarContent/> }
                                footer        = { <Footer/> }
                            />
                        </FuseTheme>
                    </div>
                </Router>
            </Provider>
       </JssProvider>
   ,
   document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js